export const squareMeterToFeet = (squareMeter) => {
  return squareMeter * 10.7639;
};
